export const PageIds = {
    GAME_VIEW_CONTAINER: 'gameViewContainer',
    GAME_VIEW_OVERLAY_CONTAINER: 'gameViewOverlayContainer',
    GAME_SKILL_TOGGLE_CONTAINER: 'gameSkillToggleContainer',
    GAME_CANVAS: 'gameCanvas',
    SKILL_TREE_GRAPH: 'skillTreeGraph',

    CENTER_ON_CHARACTER_BUTTON: 'centerOnCharacterButton',
    AUTO_PLAY_BUTTON: 'autoPlayButton',

    ACTIVE_SKILLS_PANEL: 'activeSkillsPanel',
    ACTIVE_BONUSES_PANEL: 'activeBonusesPanel',

    /**
     * The main upgrade panel on the right of the screen.
     * Contains the tab menu and the upgrade container.
     */
    PRIMARY_UPGRADE_PANEL: 'primaryUpgradePanel',

    /**
     * The div with the upgrade tabs.
     */
    PRIMARY_UPGRADE_PANEL_TAB_BAR: 'primaryUpgradePanelTabBar',
    
    UPGRADE_TAB_MENU_ITEM_CREW: 'crewUpgradesMenuItem',
    SKILL_TREE_TAB_MENU_ITEM: 'skillTreeMenuItem',

    /**
     * Free Upgrades Panel
     */
    FREE_UPGRADES_PANEL: 'freeUpgradesPanel',
    /**
     * Mined Upgrades Panel
     */
    MINED_UPGRADES_PANEL: 'minedUpgradesPanel',
    /**
     * Pick Upgrades Panel
     */
    PICK_UPGRADES_PANEL: 'pickUpgradesPanel',
    /**
     * Gold Upgrades Panel
     */
    GOLD_UPGRADES_PANEL: 'goldUpgradesPanel',
    /**
     * Bonus Panel
     */
    BONUS_PANEL: 'bonusPanel',
    /**
     * Point Upgrades Panel
     */
    POINT_UPGRADES_PANEL: 'pointUpgradesPanel',
    /**
     * Crew Upgrades Panel
     */
    CREW_UPGRADES_PANEL: 'crewUpgradesPanel',
    /**
     * Crew Upgrades Panel
     */
    SKILL_SELECTION_PANEL: 'skillSelectionPanel',
    /**
     * Skill Tree Panel
     */
    SKILL_TREE_PANEL: 'skillTreePanel',
    /**
     * Menu Panel
     */
    MENU_PANEL: 'menuPanel',

    /**
     * Crew Tab Upgrade Collection
     */
    CREW_TAB_UPGRADE_COLLECTION: 'upgradeCollection',
    /**
     * Crew Tab Contents
     */
    CREW_PICK_UPGRADE_CONTENTS: 'pickUpgradeBody',

    /**
     * The mine damage breakdown.
     */
    MINE_DAMAGE_VIEW: 'mineDamageDisplay',
    /**
     * The max row depth.
     */
    MAX_DEPTH_VIEW: 'maxDepth',
    /**
     * The max unlocked layer.
     */
    MAX_LAYER_VIEW: 'maxLayer',
    /**
     * The max unlocked layer.
     */
    CURRENT_LAYER_VIEW: 'currentLayer',
    /**
     * The crew 'mode' (what its doing right now)
     */
    CREW_MODE_VIEW: 'crewMode',
    /**
     * The current ore value.
     */
    CURRENCY_VIEW: 'currencyView',

    PRESTIGE_POPUP: 'prestigePopup',
    OFFLINE_POPUP: 'offlinePopup',
    STATISTICS_POPUP: 'statisticsPopup',
    SAVE_POPUP: 'savePopup',
    CLOSE_SKILL_TREE_POPUP: 'closeSkillTree',
    PERFORMANCE_POPUP: 'performancePopup',
    GAME_OPTIONS_POPUP: 'gameOptionsPopup',
    VERSION_POPUP: 'versionPopup'


};